module.exports = __webpack_public_path__ + "static/assets/8c59aacce1a24566f3b34a51f3ba2e77.svg";